<template>
  <section
    id="techacademy-works"
    class="co-bg-striped text-center"
  >
    <div class="co-container-md mx-auto px-4 py-20">
      <div
        class="flex items-center justify-center gap-3"
      >
        <img
          src="~/assets/images/Te/TeCommon/Sidejob/Works/icon-project-guarantee.svg"
          width="42"
          height="42"
          alt="アイコン"
          loading="lazy"
        >
        <div class="te-works-sub-title flex items-baseline font-bold">
          副業の案件を
          <div
            class="co-marker-thousand-1 mx-1 leading-tight"
          >
            <span class="te-works-sub-num font-bold">50,000</span>
            <span class="te-works-sub-yen font-bold">円分</span>
          </div>
          保証
          <span class="co-display-14 ml-1 font-normal text-co-gray-500">
            ※1
          </span>
        </div>
      </div>
      <h2 class="te-works-title mb-4 font-bold leading-normal">
        「はじめての仕事を保証」<br class="lg:hidden">さらに「営業力も身につく」
      </h2>
      <p class="mb-[3.25rem] text-center text-co-gray-600">
        スキルがあっても実績がないと、Web制作の副業を獲得するのは難しいです
        <br>
        テックアカデミーワークスで実績をつくれば、営業力も上がります
      </p>
      <div class="te-bg-guarantee relative rounded px-6 py-8 md:p-9">
        <div class="items-center justify-between md:flex">
          <div class="te-guarantee-content text-center md:text-left">
            <h3 class="co-display-7 mb-4 font-bold leading-normal">
              <span class="te-text-blue">はじめての仕事</span>を<span class="block md:inline">紹介します</span>
            </h3>
            <p class="mb-8 text-left text-co-gray-600">
              <span>実力判定テスト合格後1ヶ月以内に仕事をご紹介。まずは初心者向けの仕事から始められるので、</span>
              <span class="font-bold text-co-gray-700">実務経験なしでも安心</span>です。
            </p>
            <div class="mb-8 flex items-center justify-center rounded bg-white md:mb-0">
              <img
                class="te-image-reason mr-3 mt-3 w-auto md:mr-8"
                src="~/assets/images/Te/TeCommon/TechAcademyWorks/reason-image.svg"
                loading="lazy"
                alt="理由"
                width="59"
                height="75"
              >
              <div class="co-display-11 pb-1 font-bold leading-normal text-co-gray-600">
                <span class="te-text-blue co-display-9 font-bold">年間1000案件</span>を超える<span class="block">豊富な納品実績があるから</span>
              </div>
            </div>
          </div>
          <div class="te-guarantee-image flex items-center justify-center">
            <img
              class="w-auto"
              src="~/assets/images/Te/TeCommon/TechAcademyWorks/guarantee-image.svg"
              loading="lazy"
              alt="仕事紹介"
            >
          </div>
        </div>
        <img
          class="te-attention absolute w-auto"
          src="~/assets/images/Te/TeCommon/TechAcademyWorks/attention.svg"
          loading="lazy"
          alt="注目"
        >
      </div>
      <p class="co-display-14 mb-[3.75rem] mt-2 text-left text-co-gray-500">
        ※実力判定テスト合格後1ヶ月以内。紹介された案件をお受けにならない場合はご紹介対象外
        <br>
        ※2021年10月〜2022年9月の案件納品数
        <br>
        <span class="mr-3">※1</span>5万円分の案件提供保証は2024年8月5日以降のお申し込みされた方に受講開始から1年以内のみ保証
      </p>
      <div class="co-display-7 mb-7 items-center justify-center font-bold leading-normal md:flex md:flex-row">
        <img
          class="mx-auto mb-2 md:mb-0 md:ml-0 md:mr-4"
          src="~/assets/images/Te/TeCommon/TechAcademyWorks/moreover.svg"
          loading="lazy"
          alt="さらに"
        >
        <span class="block md:mb-1 md:inline">安心して副業できる</span>
        <span class="md:mb-1">サポートが充実</span>
      </div>
      <div class="mb-5 flex flex-wrap">
        <div class="mb-10 md:mb-0 md:w-1/2 md:pr-5">
          <div class="flex items-center">
            <div class="mb-0 mr-5 text-center md:mr-7">
              <img
                class="te-support-image"
                src="~/assets/images/Te/TeCommon/TechAcademyWorks/professional.png"
                loading="lazy"
                alt="安心の現役のプロ 徹底サポート"
              >
            </div>
            <div class="flex-1">
              <p class="co-display-13 mb-0 text-left text-co-gray-600">
                不安な初めてのお仕事もプロが納品までサポートするから安心。実務の第一歩を踏み出すのに最適です。
              </p>
            </div>
          </div>
        </div>
        <div class="md:w-1/2 md:pl-5">
          <div class="flex items-center md:flex-row-reverse">
            <div class="flex-1">
              <p class="co-display-13 mb-0 text-left text-co-gray-600">
                豊富な仕事の中から何度でも受注できるから、在宅で継続的に安定した収入を目指せます。
              </p>
            </div>
            <div class="ml-7 text-center md:ml-0 md:mr-7">
              <img
                class="te-support-image"
                src="~/assets/images/Te/TeCommon/TechAcademyWorks/earnings.png"
                loading="lazy"
                alt="毎月の安定収入を目指せる"
              >
            </div>
          </div>
        </div>
      </div>
      <TeCommonSliderWorkExample v-if="workExample" />
    </div>
  </section>
</template>

<script lang="ts">

import TeCommonSliderWorkExample from '~/components/Te/TeCommon/Slider/TeCommonSliderWorkExample.vue'

const options = {
  props: {
    workExample: { // カルーセルの表示切り替え
      type: Boolean,
      default: false,
    },
  },
  components: {
    TeCommonSliderWorkExample,
  }
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-title-circle {
  width: 2.75rem;
  height: 2.75rem;
  line-height: 2.75rem;
  background-color: #3eb1cd;
  border-radius: 50%;
  @media (min-width: 768px) {
    width: 3.125rem;
    height: 3.125rem;
    line-height: 3.125rem;
  }
}

.te-title-circle-dot {
  background-image: radial-gradient(
    circle at center,
    #3eb1cd 20%,
    transparent 20%
  );
  background-repeat: repeat-x;
  background-size: 1em .5em;
}

.te-text-blue {
  color: #3eb1cd;
}

.te-guarantee-content {
  @media (min-width: 768px) {
    width: 56%;
  }
}

.te-guarantee-image {
  @media (min-width: 768px) {
    width: 40%;
  }
}

.te-bg-guarantee {
  background-color: #e6f7fb;
}

.te-reason-image {
  @media (min-width: 768px) {
    width: 4.3125rem;
    height: 5.4375rem;
  }
}

.te-attention {
  top: -.75rem;
  left: -1rem;
}

.te-support-image {
  width: 9.875rem;
  height: 6.0625rem;
  @media (min-width: 768px) {
    width: 10.1875rem;
    height: 6.2225rem;
  }
}

.te-image-reason {
  @media (min-width: 768px) {
    width: 4.3125rem;
    height: 5.4375rem;
  }
}

.te-works-title {
  font-size: 1.5rem;
  @media (min-width: 768px) {
    font-size: 2.25rem;
  }
}

.te-works-sub-title {
  font-size: 0.875rem;
  @media (min-width: 768px) {
    font-size: 1.25rem;
  }
}

.te-works-sub-num {
  font-size: 1.5rem;
  @media (min-width: 768px) {
    font-size: 2.25rem;
  }
}

.te-works-sub-yen {
  font-size: 1rem;
  @media (min-width: 768px) {
    font-size: 1.5rem;
  }
}

.co-marker-thousand-1 {
  background: linear-gradient(transparent 70%, #fff0a1 0);
}

</style>
